import { bootstrapApplication } from "@angular/platform-browser";
import { appConfig } from "./app/app.config";
import { AppComponent } from "./app/app.component";

// Add a lightweight Safari (any version) detector and tag <html> for CSS scoping
(() => {
  try {
    const ua = navigator.userAgent || "";
    const vendor: string =
      typeof navigator !== "undefined" && "vendor" in navigator
        ? String((navigator as Navigator & { vendor?: string }).vendor || "")
        : "";
    // Safari detection: vendor is Apple and UA contains Safari but not major alternative engines
    const isAppleVendor = /Apple Computer, Inc\./i.test(vendor);
    const hasSafariToken = /\bSafari\b/i.test(ua);
    const isNotAltEngines =
      !/(Chrome|CriOS|CrMo|Chromium|Edg|OPR|OPiOS|Opera|FxiOS|Firefox|SamsungBrowser|Silk)/i.test(
        ua
      );
    const isSafari = isAppleVendor && hasSafariToken && isNotAltEngines;
    if (isSafari) {
      document.documentElement.classList.add("safari");
    }
  } catch {
    // no-op: in environments without navigator/document
  }
})();

bootstrapApplication(AppComponent, appConfig).catch(err => console.error(err));
